import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import _ from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/** TRANSLATION */
import { useTranslation } from 'react-i18next';

/** UTILS */
import * as modalSlice from 'app/slice/modal.slice';
import UseScroll from 'utils/useScroll';

/** API */

/** ROUTE */
import ArrowBack from '@mui/icons-material/ChevronLeft';
import ArrowForward from '@mui/icons-material/ChevronRight';
import { selectMe } from 'app/slice/user.slice';
import * as UseStyled from 'features/home/UseStyled';

import { Avatar, Box, Divider, Grid, TableCell, TableRow, Typography } from '@mui/material';
import { fileUrl } from 'api/api';
import FollowUpApi, { MoveStageInterFace } from 'api/follow-up.api';
import CardFollowUp from 'component/Appointment/CardFollowUp';

import PersonnelApi from 'api/setting/personnel-managements/personnel.api';
import ServicePointsArea from 'component/Appointment/ServicePointsArea';
import LabelRanking from 'component/LabelRanking';
import TreatmentHistory from 'component/Register/TreatmentHistory';
import AutocompleteSelect from 'component/Select/AutocompleteSelect';
import TableCustom from 'component/Table/TableCustom';
import { imgs } from 'constants/images';
import { FollowUpPatientStatus, patientStatuses } from 'constants/patient-statuses';
import { colors } from 'constants/theme';
import MainButton from 'new-components/buttons/main-button';
import DateInput from 'new-components/inputs/date-input';
import SelectInput from 'new-components/inputs/select-input';
import TextAreaInput from 'new-components/inputs/text-area-input';
import TextInput from 'new-components/inputs/text-input';
import TimeInput from 'new-components/inputs/time-input';
import AlertModal from 'new-components/modal/alert-modal';
import PageModal from 'new-components/modal/page-modal';
import { DragDropContext } from "react-beautiful-dnd";
import { getBranch, getCrm, getMember, renderAge, toBuddhistYear } from 'utils/app.utils';
import { dateTimeToView, dateToView, timeToView } from 'utils/date.utils';
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils';
import AppointmentHistoryTable from './appointment-history-table';
import CourseHistoryTable from './course-history-table';
import { StatusSelectorCustom } from './follow-up-status-selector';

export interface SliderFollowUpProps {
    service: any
    hasCollapse?: boolean
    setCancelCase?: any
    setPatientCase?: any
    branch: any
    reRender?: () => void
    handleFollow?: () => void
    followUpId?: number
    isEdit?: boolean
    setFollowUpId?: any
    onLoadMore?: () => void
    isLoadingMore?: boolean
    loading?: boolean
    totalCounts?: Record<number, number>
}

interface IsDraggingProps {
    isDrag: boolean
    droppableId: number
    index: number
}



export default function SliderFollowUp(props: SliderFollowUpProps) {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const memberAll = getMember()
    const user = useSelector(selectMe)
    // hideArrow,
    const { hideArrow, scrollBehavior, onPressArrow, startDragging, stopDragging, handleDragging } = UseScroll('.service-slider-container', '.service-slider-wrap', 700)
    const [configModal, setConfigModal] = useState('')
    const [patient, setPatient] = useState<any | null>([])
    const [active, setActive] = useState(0);
    const [isOpenModal, setIsOpenModal] = useState(false)

    const initStateErrorMessage = {
        username: '',
        password: '',
        cancelRemark: ''
    }
    const initStatePopupCancelFollow = {
        username: '',
        password: '',
        cancelRemark: ''
    }

    const initStateFollow = {
        detailFollow: ''
    }
    const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
    const [msgPopupCancelFollow, setMsgPopupCancelFollow] = useState(initStatePopupCancelFollow)
    const permissions = { isCreate: isCreate(), isDelete: isDelete(), isUpdate: isUpdate(), isView: isView() }

    const [isDrag, setIsDrag] = useState<boolean>(false)
    const [hideArrowDrag, setHideArrowDrag] = useState<string>('')
    const elementSlider = useRef<any>(null)
    const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null)
    const hideArrowDebounceRef = useRef<NodeJS.Timeout | null>(null)
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const branchId = Number(getBranch())
    const [pageLogs, setPageLogs] = useState(1)
    const [pageLimitLogs, setPageLimitLogs] = useState(5)
    const [rowCountLogs, setRowCountLogs] = useState(0)
    const [historyLogs, setHistoryLogs] = useState([])
    const [pageStage, setPageStage] = useState(1)
    const [pageLimitStage, setPageLimitStage] = useState(5)
    const [rowCountStage, setRowCountStage] = useState(0)
    const [historyStage, setHistoryStage] = useState([])
    const [selectedStatus, setSelectedStatus] = useState<FollowUpPatientStatus>(
        FollowUpPatientStatus.NOT_YET
    )
    const [isOpenStatusLose, setIsOpenStatusLose] = useState(false)
    const [loseDealRemark, setLoseDealRemark] = useState('')
    const [noteDetail, setNoteDetail] = useState('')

    const today = new Date().toISOString().slice(0, 10);
    const now = new Date().toTimeString().slice(0, 8);
    const [timeFollow, setTimeFollow] = useState(now)
    const [dateFollow, setDateFollow] = useState(today)
    const [channel, setChannel] = useState('โทร')
    const [userOptions, setUserOption] = useState<any>([])
    const [userId, setUserId] = useState<any>(null)
    const [detailFollow, setDetailFollow] = useState("")
    const [isOpenModalCase, setIsOpenModalCase] = useState(false)
    const [errorMessageFollow, setErrorMessageFollow] = useState(initStateFollow)
    const [errorMessageLoseDeal, setErrorMessageLoseDeal] = useState({ loseDeal: '' })

    useEffect(() => {
        patient.followUpId = props?.followUpId
    }, [props?.followUpId])

    const clearData = () => {
        setNoteDetail('')
        setLoseDealRemark('')
        setPageLogs(1)
        setPageStage(1)
        setPatient([])
        props.setFollowUpId(null)
        setErrorMessageFollow(initStateFollow)
        setIsOpenStatusLose(false)
    }

    const onCancelFollowUp = () => {
        setConfigModal('cancelFollowUp')
        dispatch(modalSlice.showModal())
    }


    const loadFindFollowUpId = async (followUpId: any) => {
        const queue = await FollowUpApi.findFollowUpId(followUpId);
        setPatient(queue.data)
        setSelectedStatus(queue.data?.followUpStatus)
        setNoteDetail(queue.data?.note)
        setUserId(user?.userId)
        setTimeFollow(now)
    };

    const onSubmitPopupFollow = () => {
        if (!msgPopupCancelFollow.username || !msgPopupCancelFollow.password || !msgPopupCancelFollow.cancelRemark) {
            return setErrorMessage({
                username: !msgPopupCancelFollow.username ? t('HOME.MESSAGE.INPUT.WARNING_USERNAME') : '',
                password: !msgPopupCancelFollow.password ? t('HOME.MESSAGE.INPUT.WARNING_PASSWORD') : '',
                cancelRemark: !msgPopupCancelFollow.cancelRemark ? t('กรุณากรอกเหตุผลเลิกติดตาม') : ''
            })
        } else {
            PersonnelApi.findPermissions({ username: msgPopupCancelFollow.username, password: msgPopupCancelFollow.password })
                .then(({ data }) => {
                    if (data?.hasUnfollow === "PERMISS") {
                        FollowUpApi.cancelFollow(patient?.followUpId, {
                            username: msgPopupCancelFollow.username,
                            password: msgPopupCancelFollow.password,
                            cancelRemark: msgPopupCancelFollow.cancelRemark
                        }).then((e) => {
                            notiSuccess('เลิกติดตามสำเร็จ')
                            props.reRender && props.reRender()
                            clearPopupFollow()
                        }).catch((e) => {
                            const message = e?.response?.data?.message
                            if (message === 'NOT_FOUND_USER' || message === 'INVALID_PASSWORD') {
                                setErrorMessage({
                                    ...initStateErrorMessage,
                                    username: message === 'NOT_FOUND_USER' ? t('PAYMENT.MESSAGE.ERROR.NOT_FOUND_USER') : '',
                                    password: message === 'INVALID_PASSWORD' ? t('PAYMENT.MESSAGE.ERROR.INVALID_PASSWORD') : ''
                                })
                            } else notiError(t('HOME.MESSAGE.ERROR.ERROR_CANCEL'))
                        })
                    } else {
                        setErrorMessage({ ...errorMessage, ...{ username: t('ชื่อผู้ใช้นี้ไม่มีสิทธิ์ในการเลิกติดตาม') } })
                        return
                    }
                })
                .catch((e) => {
                    const status = e?.response?.status
                    setErrorMessage({ ...errorMessage, ...{ username: status === 404 ? t('INPUT.NOT_FOUND_USER_NAME') : '', password: status === 400 ? t('INPUT.PASSWORD_INCORRECT') : '' } })
                })

        }
    }

    const clearPopupFollow = () => {
        setConfigModal('')
        setErrorMessage(initStateErrorMessage)
        setMsgPopupCancelFollow(initStatePopupCancelFollow)
    }


    useEffect(() => {
        const timer = setTimeout(() => {
            onPressArrow('onLoad');
        }, 0);
        return () => clearTimeout(timer);
    }, [props.hasCollapse, props.service])

    const onDragStart = () => {
        setIsDrag(true)
    }

    const onDragEnd = (result: any) => {
        if (!result.destination) {
            setIsDrag(false)
            return
        }

        const { source, destination, draggableId } = result

        if (source.droppableId === destination.droppableId && source.index === destination.index) {
            setIsDrag(false)
            return
        }
        const patientId = Number(draggableId.split('-')[0])

        const sourceStage = props.service.find((s: any) => s.stage === Number(source.droppableId))
        const draggedPatient = sourceStage?.rows.find((p: any) => p.patientId === patientId)
        if (Number(source.droppableId) === Number(destination.droppableId)) {
            setIsDrag(false)
            return
        }

        if (draggedPatient?.followUpId && destination.droppableId !== '1') {
            const payload: MoveStageInterFace = {
                stageNumberStart: Number(source.droppableId),
                stageNumberTo: Number(destination.droppableId),
            }

            FollowUpApi.moveStage(draggedPatient.followUpId, payload)
                .then(() => {
                    notiSuccess('ย้าย Stage สำเร็จ')
                    props.reRender?.()
                })
                .catch((err) => {
                    notiError('ย้าย Stage ไม่สำเร็จ')
                })
                .finally(() => {
                    setIsDrag(false)
                })
        } else if (draggedPatient?.followUpId && destination.droppableId === '1') {
            notiError('ไม่สามารถย้ายไป Stage 1 ได้')
            setIsDrag(false)
        }
        else {
            notiError('ไม่พบข้อมูลผู้ป่วยเพื่อย้าย Stage')
            setIsDrag(false)
        }
    }

    const handleOnScroll = () => {
        const el = elementSlider.current
        if (!el) return

        const scrollLeft = Math.round(el.scrollLeft)
        const offsetWidth = Math.round(el.offsetWidth)
        const scrollWidth = Math.round(el.scrollWidth)

        const threshold = 2 // เผื่อความผิดพลาดเล็กน้อยจาก float

        let newHideArrow: '' | 'prev' | 'next' | 'both' = ''
        if (scrollLeft <= threshold && scrollLeft + offsetWidth >= scrollWidth - threshold) {
            newHideArrow = 'both'
        } else if (scrollLeft + offsetWidth >= scrollWidth - threshold) {
            newHideArrow = 'next'
        } else if (scrollLeft <= threshold) {
            newHideArrow = 'prev'
        }

        // debounce setState เพื่อลด re-render ระหว่าง scroll (แก้ปัญหากระตุก)
        if (hideArrowDebounceRef.current) {
            clearTimeout(hideArrowDebounceRef.current)
        }
        hideArrowDebounceRef.current = setTimeout(() => {
            setHideArrowDrag(newHideArrow)
            hideArrowDebounceRef.current = null
        }, 80)

        // ใช้ debounce เพื่อป้องกันการเรียกซ้ำ
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current)
        }

        scrollTimeoutRef.current = setTimeout(() => {
            // เช็ค vertical scroll ของ sliderSliderFollowUp component เอง
            // หา container ที่มี vertical scroll ภายใน component นี้ (ไม่ใช่ parent จาก follow-up.tsx)
            let scrollTop = 0
            let scrollHeight = 0
            let clientHeight = 0

            // เริ่มจาก elementSlider และหา parent ที่มี vertical scroll
            // แต่ต้องหยุดก่อนที่จะออกจาก component sliderSliderFollowUp
            let current: HTMLElement | null = el
            let found = false

            while (current && !found) {
                const style = window.getComputedStyle(current)
                const hasVerticalScroll = current.scrollHeight > current.clientHeight &&
                    (style.overflow === 'auto' || style.overflowY === 'auto' || style.overflow === 'scroll' || style.overflowY === 'scroll')

                if (hasVerticalScroll) {
                    scrollTop = current.scrollTop
                    scrollHeight = current.scrollHeight
                    clientHeight = current.clientHeight
                    found = true
                    break
                }

                // หยุดถ้าเจอ boundary ของ component sliderSliderFollowUp
                // หรือเจอ container ที่มาจาก follow-up.tsx (UseStyled.Container ที่มี class pr-0)
                if (current.classList.contains('service-points') ||
                    (current.classList.contains('pr-0') && current.classList.contains('h-100'))) {
                    // หยุดที่ boundary นี้
                    break
                }

                current = current.parentElement
            }

            // ถ้าไม่เจอ container ที่มี vertical scroll ใน component นี้ ให้ใช้ elementSlider เอง
            if (!found && el) {
                scrollTop = el.scrollTop
                scrollHeight = el.scrollHeight
                clientHeight = el.clientHeight
            }

            // เช็คว่า scroll ถึงสุด height ของ sliderSliderFollowUp component
            const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100 // 100px threshold

            if (isNearBottom && props.onLoadMore && !props.isLoadingMore && !props.loading) {
                props.onLoadMore()
            }
        }, 0) // debounce 200ms
    }


    useEffect(() => {
        setHideArrowDrag(hideArrow)
    }, [hideArrow])


    const loadDataHistoryLogs = async (id?: number) => {
        try {
            await FollowUpApi.findHistoryLogsId({ page: pageLogs, pageLimit: pageLimitLogs }, patient?.followUpId || props?.followUpId || id).then((resp) => {
                setHistoryLogs(resp.data)
                setRowCountLogs(resp.headers['x-total'])
            })
        } catch (error) {
            notiError(t('ERROR'))
        }
    }

    const loadDataHistoryStage = async (id?: number) => {
        try {
            await FollowUpApi.findHistoryStageId({ page: pageStage, pageLimit: pageLimitStage }, patient?.followUpId || props?.followUpId || id).then((resp) => {
                setHistoryStage(resp.data)
                setRowCountStage(resp.headers['x-total'])
            })
        } catch (error) {
            notiError(t('ERROR'))
        }
    }

    const loadDataUsers = async () => {
        try {
            await FollowUpApi.findUsers({ page: 1, pageLimit: 100 }).then((resp) => setUserOption(_.map(resp.data, (item) => ({ doctorId: item?.userId, doctorFullname: item?.fullname })))).catch(() => notiError(t('ERROR')))
        } catch (error) {
            notiError(t('ERROR'))
        }
    }

    useEffect(() => {
        if (patient?.followUpId || props.followUpId) {
            loadDataHistoryLogs()
        }
    }, [pageLogs, pageLimitLogs, props.followUpId])


    useEffect(() => {
        if (patient?.followUpId || props.followUpId) {
            loadDataHistoryStage()
        }
    }, [pageStage, pageLimitStage, props.followUpId])

    useEffect(() => {
        loadDataUsers()
        setUserId(user.userId)

        return () => {
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current)
            }
            if (hideArrowDebounceRef.current) {
                clearTimeout(hideArrowDebounceRef.current)
            }
        }
    }, [])

    useEffect(() => {
        if (props.followUpId) {
            loadFindFollowUpId(props.followUpId)
            loadDataUsers()
            setUserId(user.userId)
            setIsOpenModal(true)
        }
    }, [props.followUpId])

    const headCells = [
        { id: 'no', disablePadding: false, label: t('ลำดับ') },
        { id: 'contact', disablePadding: false, label: t('ช่องทาง'), width: '100px' },
        { id: 'date-time', disablePadding: false, align: 'center', label: t('วันที่/เวลา') },
        { id: 'detail', disablePadding: false, label: t('รายละเอียด') },
        { id: 'updated_at', disablePadding: false, align: 'center', label: t('ผู้บันทึก') },
    ]

    const renderData = (objData: any, no: number) => {
        const index = pageLogs * pageLimitLogs - pageLimitLogs + no + 1
        const [hour, minute] = objData?.followUpTime?.split(':');
        return (
            <>
                <TableRow key={`topic-row-${no}`} className={`main-table-row`}>
                    <TableCell align="center" scope="row" className='border-0'>
                        <Typography fontSize={16} fontWeight={400}>{index}</Typography>
                    </TableCell>
                    <TableCell align="left" scope="row" className='border-0'>
                        <Typography fontSize={16} fontWeight={400}>{objData?.channel}</Typography>
                    </TableCell>
                    <TableCell align="center" scope="column" className='border-0'>
                        <Typography fontSize={16} fontWeight={400}>{dateToView(objData?.followUpDate)}</Typography>
                        <Typography fontSize={16} fontWeight={400}>{`${hour}:${minute} น.`}</Typography>
                    </TableCell>
                    <TableCell align="left" scope="row" className='border-0'>
                        <Typography>{objData?.note || '-'}</Typography>
                    </TableCell>
                    <TableCell align="center" scope="column" className='border-0'>
                        <Typography fontSize={16} fontWeight={400}>{objData?.followUpByName}</Typography>
                        <Typography fontSize={10} fontWeight={400} color="#5A5A5A">{dateToView(objData?.createdAt)} {timeToView(objData?.createdAt)} น.</Typography>
                    </TableCell>
                </TableRow>
            </>
        )
    }

    const headCellStage = [
        { id: 'no', disablePadding: false, label: t('ลำดับ') },
        { id: 'contact', disablePadding: false, label: t('สเตจเดิม'), width: '150px' },
        { id: 'date-time', disablePadding: false, label: t('สเตจใหม่'), width: '150px' },
        { id: 'detail', disablePadding: false, align: 'center', label: t('ผู้ทำรายการ') },
        { id: 'updated_at', disablePadding: false, label: t('หมายเหตุ') },
    ]

    const renderDataStage = (objData: any, no: number) => {
        const index = pageStage * pageLimitStage - pageLimitStage + no + 1
        return (
            <>
                <TableRow key={`topic-row-${no}`} className={`main-table-row`}>
                    <TableCell align="center" scope="row" className='border-0'>
                        <Typography fontSize={16} fontWeight={400}>{index}</Typography>
                    </TableCell>
                    <TableCell align="left" scope="row" className='border-0'>
                        <Typography fontSize={16} fontWeight={400}>{objData?.stageNumberStart === objData?.stageNumberTo ? '-' : renderStage(objData?.stageNumberStart)}</Typography>
                    </TableCell>
                    <TableCell align="left" scope="column" className='border-0'>
                        <Typography fontSize={16} fontWeight={400}>{renderStage(objData?.stageNumberTo)}</Typography>
                    </TableCell>
                    <TableCell align="center" scope="column" className='border-0'>
                        <Typography fontSize={16} fontWeight={400}>{objData?.patientCaseId ? 'ระบบ' : objData?.updatedBy}</Typography>
                        <Typography fontSize={10} fontWeight={400} color="#5A5A5A">{dateTimeToView(objData?.updatedAt)}</Typography>
                    </TableCell>
                    <TableCell align="left" scope="row" className='border-0'>
                        <Typography>{objData?.patientCaseId ? 'ย้ายอัตโนมัติ' : 'เจ้าหน้าที่ย้าย'}</Typography>
                    </TableCell>
                </TableRow>
            </>
        )
    }

    const handleSetAge = (date: Date | null) => {
        return `${renderAge(date, 'year')} ${t('TIME_DURATION_TYPE.YEAR')} ${renderAge(date, 'month')} ${t('TIME_DURATION_TYPE.MONTH')} ${renderAge(date, 'day')} ${t('TIME_DURATION_TYPE.DAY')}`
    }

    const renderStage = (data: number) => {
        switch (data) {
            case 1:
                return 'รายการติดตาม'
            case 2:
                return 'นัดปรึกษา'
            case 3:
                return 'วางแผนการรักษา'
            case 4:
                return 'เคลียร์ช่องปาก'
            case 5:
                return 'เริ่มการรักษา'
            case 6:
                return 'ระหว่างการรักษา'
            default:
                return "-"
        }
    }

    const onSubmitFollow = async (followUpId: number) => {
        if (!detailFollow) {
            return setErrorMessageFollow({ detailFollow: 'กรุณากรอกรายละเอียด' })
        }
        try {
            await FollowUpApi.submitFollow(followUpId, {
                followUpDate: dateFollow,
                followUpTime: timeFollow,
                channel: channel,
                note: detailFollow,
                followUpById: userId
            }).then(() => {
                setDetailFollow('')
                notiSuccess('บันทึกการติดตามสำเร็จ')
                loadDataHistoryLogs()
                props.reRender && props.reRender()
            }).catch(() => notiError(t('ERROR')))

        } catch (error) {
            notiError(t('ERROR'))
        }
    }

    const getPatientStatusByState = (state: number) => {
        switch (state) {

            // ----------------- STATE 1 -----------------
            case 1:
                return {
                    NOT_YET: patientStatuses.NOT_YET,
                    CONFIRM: patientStatuses.CONFIRM,
                    NO_CONTACT: patientStatuses.NO_CONTACT,
                    NO_ANSWER: patientStatuses.NO_ANSWER,
                    WRONG_NUMBER: patientStatuses.WRONG_NUMBER,
                    ARRIVED: patientStatuses.ARRIVED,
                    NO_SHOW: patientStatuses.NO_SHOW,
                    PUT_OFF: patientStatuses.PUT_OFF,
                    REJECT: patientStatuses.REJECT,
                };

            // ----------------- STATE 2 -----------------
            case 2:
                return {
                    CONSULT: patientStatuses.CONSULT,
                    READY: patientStatuses.READY,
                    NOT_READY: patientStatuses.NOT_READY,
                    LOSE: patientStatuses.LOSE,
                };

            // ----------------- STATE 3 -----------------
            case 3:
                return {
                    PLAN: patientStatuses.PLAN,
                    READY: patientStatuses.READY,
                    NOT_READY: patientStatuses.NOT_READY,
                    LOSE: patientStatuses.LOSE,
                };

            // ----------------- STATE 4 -----------------
            case 4:
                return {
                    READY: patientStatuses.READY,
                    NOT_READY: patientStatuses.NOT_READY,
                    LOSE: patientStatuses.LOSE,
                };

            // ----------------- STATE 5 -----------------
            case 5:
                return {
                    DONE: patientStatuses.DONE,
                    FOLLOW: patientStatuses.FOLLOW,
                    CANCEL: patientStatuses.CANCEL,
                };
            case 6:
                return {
                    DONE: patientStatuses.DONE,
                    FOLLOW: patientStatuses.FOLLOW,
                    CANCEL: patientStatuses.CANCEL,
                };

            default:
                return {};
        }
    };

    const handlePatientCode = useCallback(() => {
        switch (props.branch?.patientCodeQueue) {
            case '1': return patient.cnNumber ?? '';
            case '0': return patient.branchCnNumber ?? '';
            case '2': return patient.snCode ?? '';
            default: return patient.cnNumber
            // default: return '';
        }
    }, [props.branch?.patientCodeQueue, patient])

    const finishCase = async () => {
        await FollowUpApi.finishCase(patient?.followUpId).then((resp) => {
            notiSuccess('ปิดเคสสำเร็จ')
            setIsOpenModalCase(false)
            setIsOpenModal(false)
            props.reRender && props.reRender()
            loadFindFollowUpId(patient?.followUpId)
        }).catch(() => notiError(t('ERROR')))
    }

    return (
        <>
            <AlertModal
                isOpen={isOpenStatusLose}
                title='กรุณาเลือกเหตุผลของการ Lose Deal ก่อนดำเนินการต่อ'
                type='warning'
                handleClose={() => {
                    setErrorMessageLoseDeal({ loseDeal: '' })
                    setIsOpenStatusLose(false)
                }}
                onCancel={{
                    onClick: () => {
                        setErrorMessageLoseDeal({ loseDeal: '' })
                        setIsOpenStatusLose(false)
                    }
                }}
                onSubmit={{
                    onClick: () => {
                        if (!loseDealRemark) {
                            setErrorMessageLoseDeal({ loseDeal: 'กรุณาเลือกเหตุผล Lose Deal' })
                            return
                        }
                        FollowUpApi.status(patient?.followUpId, { status: 'LOSE', loseDealRemark: loseDealRemark }).then((resp) => {
                            setSelectedStatus(FollowUpPatientStatus.LOSE)
                            setLoseDealRemark('')
                            setIsOpenStatusLose(false)
                            loadFindFollowUpId(patient?.followUpId)
                            props?.reRender && props.reRender()
                            notiSuccess('แก้ไขสถานะสำเร็จ')
                        }).catch(() => notiError(t('ERROR')))
                    }, title: 'ยืนยัน'
                }}
            >
                <Box>
                    <SelectInput
                        onChange={(e) => setLoseDealRemark(e.target.value)}
                        value={loseDealRemark}
                        options={[
                            { name: "ย้ายที่อยู่ใหม่", value: "ย้ายที่อยู่ใหม่" },
                            { name: "เปลี่ยนประเภทการรักษา", value: "เปลี่ยนประเภทการรักษา" },
                            { name: "ไม่พึงพอใจ", value: "ไม่พึงพอใจ" },
                            { name: "ไปทำคลินิกอื่น", value: "ไปทำคลินิกอื่น" },
                        ]}
                        label='เลือกเหตุผลของการ Lose Deal '
                        required
                        helperText={errorMessageLoseDeal.loseDeal || ''}
                    />
                </Box>
            </AlertModal>
            <AlertModal
                isOpen={isOpenModalCase}
                title='ยืนยันการปิดเคส'
                message={`ผู้ป่วยรายนี้ได้ทำการรักษาตามแผนทั้งหมดเรียบร้อยแล้ว\nหากยืนยัน ระบบจะนำเคสออกจากบอร์ดติดตามทันที\nคุณต้องการปิดเคสนี้หรือไม่?`}
                type='warning'
                handleClose={() => setIsOpenModalCase(false)}
                onCancel={{
                    onClick: () => setIsOpenModalCase(false)
                }}
                onSubmit={{
                    onClick: () => finishCase(), title: 'ยืนยัน'
                }}
            >

            </AlertModal>
            <PageModal
                isOpen={isOpenModal}
                size='M'
                title='ข้อมูลผู้ป่วย'
                handleClose={() => {
                    setIsOpenModal(false)
                    clearData()
                }}
                onCancel={{
                    onClick: () => {
                        setIsOpenModal(false)
                        clearData()
                    }
                }}
                onCloseSubmit
                onSubmit={{ onClick: () => null }}
                overflow
                childrenTopLeft={<Box display="flex" flexDirection='row' alignItems="center" gap="8px">
                    <Typography fontSize={14} fontWeight={500}>สถานะ :</Typography> <Box fontSize={14} fontWeight={600} sx={{ border: 1, bgcolor: patient?.stageNumber === 1 ? '#EBB912' : '#1CB99A', borderRadius: '26px', color: 'white', paddingX: '8px', paddingY: '4px' }}>Stage {patient?.stageNumber}: {renderStage(patient?.stageNumber)}</Box>
                </Box>}
            >
                <Box paddingTop="16px">
                    <Grid container>
                        <Grid xs={2}>
                            <Avatar alt={patient.cnNumber} src={`${fileUrl}/${patient?.avatar}`} className="mx-auto" sx={{ width: '140px', height: '140px', border: `3px solid ${getCrm() ? _.find(memberAll, { rankId: patient.rankId })?.color : '#DFDFDF'}`, backgroundColor: colors.white }}>
                                <img src={(!patient?.avatar || patient?.avatar === '/') ? imgs.defaultAvatar : `${fileUrl}/${patient?.avatar}`} alt="" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
                            </Avatar>
                        </Grid>
                        <Grid xs={10} paddingLeft="24px">
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Box display="flex" flexDirection="row" gap="16px">
                                    <Typography fontSize={20} fontWeight={500} color="#2F4269">{handlePatientCode()} {handlePatientCode() && '|'} {patient?.firstname} {patient?.lastname}</Typography>
                                    {getCrm() && <LabelRanking rankId={patient?.rankId} />}
                                </Box>
                                <Typography color="#2F4269">ใช้บริการล่าสุด {patient?.lastVisit ? toBuddhistYear(moment(patient?.lastVisit), "DD/MM/YYYY") : '-'}</Typography>
                            </Box>
                            <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '-4px !important', marginRight: '-4px !important', marginY: '16px' }} />
                            <Grid container spacing={2} paddingLeft="18px" paddingTop="16px">
                                <Grid xs={6}>
                                    <Grid container>
                                        <Grid xs={4}>เลขบัตรประชาชน</Grid>
                                        <Grid xs={8}>{patient?.idCard || '-'}</Grid>
                                        <Grid xs={4}>วัน เดือน ปีเกิด</Grid>
                                        <Grid xs={8}>{patient?.dateOfBirth ? toBuddhistYear(moment(patient?.dateOfBirth), "DD/MM/YYYY") : '-'}</Grid>
                                        <Grid xs={4}>อายุ</Grid>
                                        <Grid xs={8}>{patient?.dateOfBirth ? handleSetAge(patient?.dateOfBirth) : '-'}</Grid>
                                        <Grid xs={4}>เพศ</Grid>
                                        <Grid xs={8}>{t(`REGISTER.FORM.GENDER_OPTION.${patient?.gender}`)}</Grid>
                                        <Grid xs={4}>สถานะ</Grid>
                                        <Grid xs={8}>
                                            <Box display="flex" flexDirection="row" alignItems="center" gap="8px">
                                                <StatusSelectorCustom
                                                    optionPatientStatuses={getPatientStatusByState(patient?.stageNumber)}
                                                    status={selectedStatus}
                                                    onChange={(newStatus) => {
                                                        if (newStatus === 'LOSE') {
                                                            setIsOpenStatusLose(true)
                                                        } else {
                                                            setSelectedStatus(newStatus)
                                                            FollowUpApi.status(patient?.followUpId, { status: newStatus }).then(() => {
                                                                notiSuccess('แก้ไขสถานะสำเร็จ')
                                                                loadFindFollowUpId(patient?.followUpId)
                                                                props.reRender && props.reRender()
                                                            }).catch(() => notiError(t('ERROR')))
                                                        }
                                                    }}
                                                    disabled={patient.status === 'UNFOLLOW' || patient.status === 'SUCCESS' || patient.status === 'CANCEL'}
                                                />
                                                {((patient?.stageNumber === 5 || patient?.stageNumber === 6) && patient?.followUpStatus !== 'FOLLOW') &&
                                                    <Box onClick={() => {
                                                        if (patient.status !== 'UNFOLLOW' && patient.status !== 'SUCCESS' && patient.status !== 'CANCEL') {
                                                            setIsOpenModalCase(true)
                                                        } else setIsOpenModalCase(false)
                                                    }}
                                                        display="flex" flexDirection="row" alignItems="center" border={1} height={24} bgcolor="white"
                                                        borderColor={patient.status === 'UNFOLLOW' || patient.status === 'SUCCESS' || patient.status === 'CANCEL' ? "#AEAFAF" : "#1CB99A"}
                                                        color={patient.status === 'UNFOLLOW' || patient.status === 'SUCCESS' || patient.status === 'CANCEL' ? "#AEAFAF" : "#1CB99A"}
                                                        borderRadius="4px" gap="4px" paddingX="8px" sx={{ cursor: patient.status === 'UNFOLLOW' || patient.status === 'SUCCESS' || patient.status === 'CANCEL' ? "default" : 'pointer' }}>
                                                        <FolderSharedOutlinedIcon />
                                                        <Typography fontSize={14} fontWeight={400}>ปิดเคส</Typography>
                                                    </Box>}
                                            </Box>

                                            {(patient?.loseDealRemark && patient?.followUpStatus === "LOSE") && <Typography fontSize={10} fontWeight={400} color="#FB5252">เหตุผล : {patient?.loseDealRemark || ''}</Typography>}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid xs={6}>
                                    <Grid container>
                                        <Grid xs={4}>เบอร์มือถือ</Grid>
                                        <Grid xs={8}>{patient?.phone || '-'}</Grid>
                                        <Grid xs={4}>เบอร์บ้าน</Grid>
                                        <Grid xs={8}>{patient?.telephone || '-'}</Grid>
                                        <Grid xs={4}>ไลน์</Grid>
                                        <Grid xs={8}>{patient?.line || '-'}</Grid>
                                        <Grid xs={4}>เฟซบุ๊ค</Grid>
                                        <Grid xs={8}>{patient?.facebook || '-'}</Grid>
                                        <Grid xs={4}>อีเมล</Grid>
                                        <Grid xs={8}>{patient?.email || '-'}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Box display="flex" justifyContent="space-between" alignItems="center" paddingBottom="8px">
                        <Typography fontSize={16} fontWeight={500} color="#2F4269" paddingTop="16px">บันทึกเพิ่มเติม</Typography>
                        <MainButton title='บันทึกข้อมูลเพิ่มเติม' disabled={!noteDetail} type='primary' variant='outlined' onClick={() => FollowUpApi.noteDetail(patient?.followUpId, { note: noteDetail }).then(() => {
                            notiSuccess('บันทึกข้อมูลสำเร็จ')
                            props.reRender && props.reRender()
                        }).catch(() => notiError(t('ERROR')))} />
                    </Box>
                    <TextAreaInput
                        placeholder='กรอกข้อมูลเพิ่มเติมที่นี่'
                        rows={3}
                        fullWidth
                        onChange={(e) => setNoteDetail(e.target.value)}
                        value={noteDetail}
                        maxLength={255}
                        inputProps={{
                            style: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'flex-start',
                                fontSize: "12px"
                            },
                            startAdornment: (
                                <Box sx={{ position: "absolute", bottom: "2px" }}>
                                    <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${noteDetail?.length || 0}/255`}</Box>
                                </Box>
                            )
                        }}
                    />

                    <Grid container sx={{ paddingTop: '16px' }}>
                        <Grid xs={7}>
                            <Box marginRight="16px">
                                <Box display="flex" flexDirection="column" width="100%" paddingBottom="16px">
                                    <Box display="flex" flexDirection="row">
                                        {['ข้อมูลการติดตาม', 'ประวัติการรักษา', 'ประวัตินัดหมาย', 'ประวัติคอร์ส'].map((item, index) => (
                                            <Box
                                                key={item}

                                                onClick={() => {
                                                    setActive(index)
                                                }}
                                                sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    fontSize: '16px',
                                                    fontWeight: 400,
                                                    color: active === index ? '#35b4a4' : '#000',
                                                }}
                                            >
                                                {item}

                                                <Box
                                                    sx={{
                                                        height: '3px',
                                                        bgcolor: active === index ? '#35b4a4' : '#e2e2e2',
                                                        width: '100%',
                                                        borderRadius: '2px',
                                                        mt: '4px',
                                                    }}
                                                />
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>

                                {active === 0 && <>
                                    <TableCustom
                                        page={pageLogs}
                                        pageLimit={pageLimitLogs}
                                        sortType={'ASC'}
                                        sortBy={''}
                                        rowCount={rowCountLogs}
                                        headCells={headCells}
                                        rowsData={_.map(historyLogs, (topic, index: number) => {
                                            return renderData(topic, index)
                                        })}
                                        textEmptyData={t('ยังไม่มีข้อมูล')}
                                        onSort={() => {
                                            return
                                        }}
                                        setPageLimit={(e) => setPageLimitLogs(e)}
                                        setPage={(e) => setPageLogs(e)}
                                        maxHeight={300}
                                        overflowY="auto"
                                    />

                                    <Box marginTop="16px">
                                        <TableCustom
                                            page={pageStage}
                                            pageLimit={pageLimitStage}
                                            sortType={'ASC'}
                                            sortBy={''}
                                            rowCount={rowCountStage}
                                            headCells={headCellStage}
                                            rowsData={_.map(historyStage, (topic, index: number) => {
                                                return renderDataStage(topic, index)
                                            })}
                                            textEmptyData={t('ยังไม่มีข้อมูล')}
                                            onSort={() => {
                                                return
                                            }}
                                            setPageLimit={(e) => setPageLimitStage(e)}
                                            setPage={(e) => setPageStage(e)}
                                            maxHeight={300}
                                            overflowY="auto"
                                        />
                                    </Box>
                                </>}
                                {active === 1 && <TreatmentHistory patientId={patient?.patientId} />}
                                {active === 2 && <AppointmentHistoryTable patientId={patient?.patientId} />}
                                {active === 3 && <CourseHistoryTable patientId={patient?.patientId} patient={patient} />}
                            </Box>
                        </Grid>
                        <Grid xs={5}>
                            <Box sx={{ borderRadius: '10px', backgroundColor: 'white', width: '100%', display: 'flex', flexDirection: 'column', padding: '16px', gap: '16px' }}>
                                <Typography fontSize={20} fontWeight={500} color="#2F4269" align='center' paddingTop="24px">การติดตาม</Typography>
                                <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '0px !important', marginRight: '0px !important', }} />

                                <Box display="flex" flexDirection="row" alignItems="center" gap="8px">
                                    <Box width="50%">
                                        <DateInput onChange={(e) => setDateFollow(moment(e).format('YYYY-MM-DD'))} value={dateFollow} label='วันที่ติดตาม' required fullWidth language='TH' disabledDateFuture />
                                    </Box>
                                    <Box width="50%">
                                        <TimeInput startHour='00:00' endHour='23:59' value={timeFollow} onChange={(e) => setTimeFollow(e)} label='เวลาที่ติดตาม' required fullWidth />
                                    </Box>
                                </Box>
                                <AutocompleteSelect
                                    required={true}
                                    inputLabel={t('APPOINTMENT.FORM.DOCTOR')}
                                    noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                                    value={_.find(userOptions, { doctorId: userId })}
                                    onchange={(event, val) => setUserId(val.doctorId)}
                                    labelId="dentist"
                                    options={userOptions}
                                    getOptionLabel={(option: any) => option.doctorFullname}
                                    disableClearable
                                />
                                {/* <SelectInput onChange={(e) => setUserId(e.target.value)} options={userOptions} value={userId} required label='ผู้บันทึก' /> */}
                                <SelectInput onChange={(e) => setChannel(e.target.value)} options={[
                                    { name: "โทร", value: "โทร" },
                                    { name: "ไลน์", value: "ไลน์" },
                                    { name: "อีเมล", value: "อีเมล" },
                                    { name: "เฟซบุ๊ค", value: "เฟซบุ๊ค" },
                                    { name: "แอปพลิเคชัน", value: "แอปพลิเคชัน" },
                                    { name: "SMS", value: "SMS" },
                                    { name: "อินสตาแกรม", value: "อินสตาแกรม" },
                                    { name: "Tiktok", value: "Tiktok" },
                                ]} required label='ช่องทาง' value={channel} defaultValue={'PHONE'} />
                                <TextAreaInput
                                    label='รายละเอียด'
                                    required
                                    rows={3}
                                    value={detailFollow}
                                    onChange={(e) => {
                                        setErrorMessageFollow({ detailFollow: '' })
                                        setDetailFollow(e.target.value)
                                    }}
                                    maxLength={255}
                                    inputProps={{
                                        style: {
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            alignItems: 'flex-start',
                                            fontSize: "12px"
                                        },
                                        startAdornment: (
                                            <Box sx={{ position: "absolute", bottom: "2px" }}>
                                                <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${detailFollow?.length || 0}/255`}</Box>
                                            </Box>
                                        ),
                                    }}
                                    helperText={errorMessageFollow.detailFollow}
                                />


                                <Box display="flex" justifyContent="end" alignItems="center" gap="16px" paddingTop="48px">
                                    <MainButton title='บันทึก' type='primary' variant='contained' style={{ width: '120px' }} onClick={() => onSubmitFollow(patient?.followUpId)} />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </PageModal>
            <AlertModal
                isOpen={isOpenAlertModal}
                title='ยืนยันยกเลิกคิวการรักษา'
                message={`ไม่สามารถย้ายคิวผู้ป่วยได้ เนื่องจากผู้ป่วยทำรายการรักษา \n คุณต้องการยกเลิกคิวการรักษาเพื่อย้ายคิวผู้ป่วย ใช่หรือไม่`}
                type='error'
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{
                    onClick: () => {
                        setIsDrag(false)
                        setIsOpenAlertModal(false)
                    }
                }}
                onSubmit={{
                    onClick: () => {
                        setIsOpenAlertModal(false)
                    }, title: 'ยืนยัน'
                }}
            />
            <UseStyled.AreaArrow
                className={`arrow-prev ${hideArrowDrag === 'prev' || hideArrowDrag === 'both' ? 'd-none' : ''}`}
                onClick={() => onPressArrow('onPrev')}
                style={{
                    height: 'fit-content',
                    margin: 'auto'
                }}
            >
                <UseStyled.CustomIconButton>
                    <ArrowBack />
                </UseStyled.CustomIconButton>
            </UseStyled.AreaArrow>
            <UseStyled.AreaArrow
                className={`arrow-next ${hideArrowDrag === 'next' || hideArrowDrag === 'both' ? 'd-none' : ''}`}
                onClick={() => onPressArrow('onNext')}
                style={{
                    height: 'fit-content',
                    margin: 'auto'
                }}
            >
                <UseStyled.CustomIconButton>
                    <ArrowForward />
                </UseStyled.CustomIconButton>
            </UseStyled.AreaArrow>

            <UseStyled.SliderContainer
                ref={elementSlider}
                onScroll={() => handleOnScroll()}
                className={'service-slider-container h-100'}
                style={{ scrollBehavior: !isDrag ? scrollBehavior : undefined }}
            >
                <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd} >
                    <div className={'d-flex service-slider-wrap'} style={{ height: 'fit-content', paddingRight: '0px' }}>
                        {_.map(props.service, (item: any, index: number) => {
                            const stageMeta = [
                                { stageType: 'FOLLOW_UP', stageName: 'รายการติดตาม', stageNameEn: 'รายการติดตาม' },
                                { stageType: 'CONSULT', stageName: 'นัดปรึกษา', stageNameEn: 'นัดปรึกษา' },
                                { stageType: 'PLAN', stageName: 'วางแผนการรักษา', stageNameEn: 'วางแผนการรักษา' },
                                { stageType: 'CLEAR', stageName: 'เคลียร์ช่องปาก', stageNameEn: 'เคลียร์ช่องปาก' },
                                { stageType: 'TREATMENT', stageName: 'เริ่มการรักษา', stageNameEn: 'เริ่มการรักษา' },
                                { stageType: 'WAITINGTREATMENT', stageName: 'ระหว่างการรักษา', stageNameEn: 'ระหว่างการรักษา' },
                            ];
                            const totalCount = props.totalCounts?.[item.stage] ?? item.count ?? 0
                            const currentRows = item.rows?.length ?? 0
                            const hasMoreData = totalCount > currentRows
                            const isLoading = props.isLoadingMore && hasMoreData
                            const showNoMoreData = totalCount > 0 && !hasMoreData && !props.loading

                            return (
                                <ServicePointsArea
                                    type='follow-up'
                                    key={item?.stage}
                                    servicePointId={item?.stage}
                                    headerName={`Stage ${item?.stage} ${i18n.language === 'th' ? stageMeta[item.stage - 1]?.stageName : stageMeta[item.stage - 1]?.stageNameEn || '-'} (${item?.count})`}
                                    serviceType={stageMeta[item.stage - 1]?.stageType}
                                    isLoading={isLoading}
                                    showNoMoreData={showNoMoreData}
                                    noMoreDataText={t('ไม่มีข้อมูลเพิ่มเติมแล้ว')}
                                    onScrollBottom={props.onLoadMore}
                                    hasMoreData={hasMoreData}
                                    body={
                                        _.map(_.orderBy(item.rows, ['sorting'], ['asc']), (patient: any, indexPatient: number) => {
                                            const draggableId = `${patient.patientId}-${indexPatient}`
                                            return (
                                                <CardFollowUp
                                                    draggableId={draggableId}
                                                    key={draggableId}
                                                    number={Number(indexPatient)}
                                                    serviceType={stageMeta[item.stage - 1]?.stageType}
                                                    patient={patient}
                                                    onClick={() => {
                                                        if (permissions.isUpdate.disabled) {
                                                            setIsOpenModal(false)
                                                        } else {
                                                            setChannel('โทร')
                                                            setDateFollow(today)
                                                            setTimeFollow(now)
                                                            setDetailFollow('')
                                                            setPatient(patient)
                                                            setSelectedStatus(patient?.followUpStatus)
                                                            setNoteDetail(patient?.note)
                                                            setUserId(user?.userId)
                                                            setTimeFollow(now)
                                                            setActive(0)
                                                            loadDataHistoryLogs(patient?.followUpId)
                                                            loadDataHistoryStage(patient?.followUpId)
                                                            setIsOpenModal(true)
                                                        }
                                                    }}
                                                    onCancel={() => {
                                                        setPatient(patient)
                                                        onCancelFollowUp()
                                                    }}
                                                    onSendMessage={() => {
                                                        setChannel('โทร')
                                                        setDateFollow(today)
                                                        setTimeFollow(now)
                                                        setDetailFollow('')
                                                        setPatient(patient)
                                                        setSelectedStatus(patient?.followUpStatus)
                                                        setNoteDetail(patient?.note)
                                                        setUserId(user?.userId)
                                                        setTimeFollow(now)
                                                        setActive(0)
                                                        loadDataHistoryLogs(patient?.followUpId)
                                                        loadDataHistoryStage(patient?.followUpId)
                                                        setIsOpenModal(true)
                                                    }}
                                                    branch={props.branch}
                                                    isDrag={isDrag}
                                                />
                                            )
                                        })
                                    }
                                />
                            )
                        })}
                    </div >
                </DragDropContext>
            </UseStyled.SliderContainer >
            {(configModal === 'cancelFollowUp' && (
                <PageModal
                    isOpen
                    size="S"
                    title='ยืนยันการเลิกติดตาม'
                    handleClose={clearPopupFollow}
                    onCancel={{ onClick: clearPopupFollow, title: t('MODAL.CANCEL') }}
                    onSubmit={{ onClick: () => onSubmitPopupFollow(), title: t('ยืนยัน'), type: 'danger' }}
                >
                    <Box display="flex" flexDirection="column" gap="16px">
                        <Typography fontSize={14}>กรุณากรอกข้อมูลประกอบเพื่อยืนยันการเลิกติดตามผู้ป่วยรายนี้: {patient?.cnNumber} {patient?.firstname} {patient?.lastname}
                        </Typography>
                        <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                            <TextInput
                                fullWidth
                                required
                                label={t('HOME.MODAL.CANCEL_VISIT.USER_NAME')}
                                onChange={(event) => {
                                    setMsgPopupCancelFollow({ ...msgPopupCancelFollow, ...{ username: event.target.value } })
                                    setErrorMessage(initStateErrorMessage)
                                }}
                                marginBottomErrorText='8px'
                                helperText={errorMessage?.username}
                            />
                            <TextInput
                                fullWidth
                                required
                                label={t('HOME.MODAL.CANCEL_VISIT.USER_PASSWORD')}
                                type='password'
                                onChange={(event) => {
                                    setMsgPopupCancelFollow({ ...msgPopupCancelFollow, ...{ password: event.target.value } })
                                    setErrorMessage(initStateErrorMessage)
                                }}
                                marginBottomErrorText='8px'
                                helperText={errorMessage?.password}
                            />
                        </Box>
                        <TextAreaInput
                            fullWidth
                            required
                            label={t('เหตุผลเลิกติดตาม')}
                            onChange={(event) => {
                                setMsgPopupCancelFollow({ ...msgPopupCancelFollow, ...{ cancelRemark: event.target.value } })
                                setErrorMessage(initStateErrorMessage)
                            }}
                            helperText={errorMessage?.cancelRemark}
                            maxLength={500}
                            inputProps={{
                                style: {
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems: 'flex-start',
                                    fontSize: "12px"
                                },
                                startAdornment: (
                                    <Box sx={{ position: "absolute", bottom: "2px" }}>
                                        <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${msgPopupCancelFollow.cancelRemark?.length || 0}/500`}</Box>
                                    </Box>
                                )
                            }}
                        />
                    </Box>
                </PageModal>
            ))}
        </>
    )
}
